module.exports = __webpack_public_path__ + "static/eindruecke5-0fc0ad7433788d3ff33b58d89653bece.jpg";